import React from 'react';
import muncieMap from 'assets/images/muncie-map.jpeg';

import useProperties from 'hooks/useProperties';

import AsyncIndicator from 'ui-kit/async-indicator/async-indicator';

import './style.css';

const Property = ({ property, onClick, onFocus, onBlur }) => {
    const images = property?.images?.split(',');

    const propertyPromotionImage = images && images.length > 0 && images[0].length > 0 ? images[0] : muncieMap;

    const backgroundStyle = {
        backgroundImage: `url(${propertyPromotionImage})`,
        backgroundSize: 'cover',
        backgroundPositionY: 'center',
        width: '100%'
    };

    const handleFocus = () => {
        if (onFocus) onFocus({ property });
    };

    return (
        <div className="property">
            <div
                className="property-background"
                style={backgroundStyle}
                onClick={() => onClick({ id: property?.id })}
                role="button"
                tabIndex={0}
                onFocus={handleFocus}
                onBlur={onBlur}
                onMouseOver={handleFocus}
            />
            <div className="details">
                <div>{property?.address}</div>
                <div>Starting Bid: ${property?.startingBid}</div>
            </div>
        </div>
    );
};

const PropertiesMapList = ({ onPropertyClick, onFocus, onBlur }) => {
    const { isFetchingProperties, properties } = useProperties();

    return (
        <div className="property-map-list">
            {isFetchingProperties && <AsyncIndicator message="Loading Properties..." />}
            {!isFetchingProperties &&
                properties.map((property, idx) => (
                    <Property
                        key={`property-map-list-${idx}`}
                        property={property}
                        onClick={onPropertyClick}
                        onFocus={onFocus}
                        onBlur={onBlur}
                    />
                ))}
        </div>
    );
};

export default PropertiesMapList;
